import { client, unwrap } from './client';

/**
 * Lightweight admin profile returned by the magic-link verify endpoint.
 * The server returns more fields than this; we only persist what the
 * sidebar + topbar need so localStorage stays compact and stale-data
 * risk stays low.
 */
export interface AdminSummary {
  id: string;
  name: string;
  email: string;
  role: string; // always 'admin' for this surface
}

export async function requestMagicLink(email: string): Promise<void> {
  await client.post('/admin-auth/request-link', { email });
}

export async function verifyMagicLink(
  token: string
): Promise<{ token: string; admin: AdminSummary }> {
  return unwrap(client.post('/admin-auth/verify', { token }));
}
